module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "07a2":
/***/ (function(module, exports) {

module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ "2f62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.1.1
 * (c) 2019 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {}

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {}

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {}
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {}

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {}
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {}
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {}
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {}
    return
  }

  try {
    this._actionSubscribers
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if (false) {}
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return result.then(function (res) {
    try {
      this$1._actionSubscribers
        .filter(function (sub) { return sub.after; })
        .forEach(function (sub) { return sub.after(action, this$1.state); });
    } catch (e) {
      if (false) {}
    }
    return res
  })
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {}
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {}

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {}

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure enviroment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {}
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {}
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {}

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {}
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {}
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {}
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.1.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};

/* unused harmony default export */ var _unused_webpack_default_export = (index_esm);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "368f":
/***/ (function(module, exports) {

module.exports = require("@fortawesome/free-solid-svg-icons");

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "b0b2":
/***/ (function(module, exports) {

module.exports = require("@fortawesome/fontawesome-svg-core");

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./src/store/slideOverStore.ts
var exportState = {
    panels: [],
};
var mutations = {
    open: function (state, payload) {
        state.panels.push(payload);
    },
    close: function (state) {
        state.panels.pop();
    },
    closeAll: function (state) {
        state.panels = [];
    },
};
var actions = {};
var getters = {};
var namespaced = true;
var slideOverModule = {
    namespaced: namespaced,
    state: exportState,
    getters: getters,
    actions: actions,
    mutations: mutations,
};

// CONCATENATED MODULE: ./src/store/store.ts

var storeNamespace = 'bacComponents';
var store;
function initStore(clientAppStore) {
    store = clientAppStore;
    var rootModule = {
        namespaced: true,
        modules: {
            slideOver: slideOverModule,
        },
    };
    clientAppStore.registerModule(storeNamespace, rootModule);
}

// EXTERNAL MODULE: external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_ = __webpack_require__("b0b2");

// EXTERNAL MODULE: external "@fortawesome/free-solid-svg-icons"
var free_solid_svg_icons_ = __webpack_require__("368f");

// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__("07a2");

// CONCATENATED MODULE: ./src/init/initFontAwesome.ts



fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faArrowLeft"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faBars"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faCaretDown"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faChevronDown"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faChevronRight"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faPlane"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faSignOutAlt"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faTimes"]);
fontawesome_svg_core_["library"].add(free_solid_svg_icons_["faUserCircle"]);
/* harmony default export */ var initFontAwesome = (function (vue) {
    vue.component('font-awesome-icon', vue_fontawesome_["FontAwesomeIcon"]);
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/block/Block.vue?vue&type=template&id=37eecf76&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-block"},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/block/Block.vue?vue&type=template&id=37eecf76&

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.1.0
  * (c) 2015-present Evan You
  * @license MIT
  */


// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return external_vue_default.a.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof external_vue_default.a
        ? superProto.constructor
        : external_vue_default.a;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function vue_class_component_esm_Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.1.1 MIT LICENSE copyright 2018 kaorun343 */
/// <reference types='reflect-metadata'/>




/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) && typeof options !== 'function' && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/block/Block.vue?vue&type=script&lang=ts&


var Blockvue_type_script_lang_ts_Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Block = __decorate([
        vue_class_component_esm
    ], Block);
    return Block;
}(external_vue_default.a));
/* harmony default export */ var Blockvue_type_script_lang_ts_ = (Blockvue_type_script_lang_ts_Block);

// CONCATENATED MODULE: ./src/components/block/Block.vue?vue&type=script&lang=ts&
 /* harmony default export */ var block_Blockvue_type_script_lang_ts_ = (Blockvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/block/Block.vue





/* normalize component */

var component = normalizeComponent(
  block_Blockvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var block_Block = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/breadcrumb/Breadcrumb.vue?vue&type=template&id=448e3c3c&
var Breadcrumbvue_type_template_id_448e3c3c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbRoutes.length > 1)?_c('ul',{staticClass:"bac-breadcrumb"},_vm._l((_vm.breadcrumbRoutes),function(route,index){return _c('li',{key:route.name,staticClass:"bac-breadcrumb__item"},[(index !== _vm.breadcrumbRoutes.length - 1)?_c('span',[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.clicked(route.name)}}},[_vm._v(_vm._s(route.meta.breadcrumb(_vm.$route.params)))]),_c('font-awesome-icon',{staticClass:"bac-breadcrumb__item__separator",attrs:{"icon":"chevron-right"}})],1):_c('span',[_vm._v(_vm._s(route.meta.breadcrumb(_vm.$route.params)))])])}),0):_vm._e()}
var Breadcrumbvue_type_template_id_448e3c3c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/breadcrumb/Breadcrumb.vue?vue&type=template&id=448e3c3c&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/breadcrumb/Breadcrumb.vue?vue&type=script&lang=ts&


var Breadcrumbvue_type_script_lang_ts_Breadcrumb = /** @class */ (function (_super) {
    __extends(Breadcrumb, _super);
    function Breadcrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Breadcrumb.prototype, "breadcrumbRoutes", {
        get: function () {
            return this.$route.matched.filter(function (r) { return !!r.meta.breadcrumb; });
        },
        enumerable: true,
        configurable: true
    });
    Breadcrumb.prototype.created = function () {
        if (!this.$route) {
            throw new Error('The Breadcrumb component depends on Vue Router. Please add Vue Router to your project');
        }
    };
    Breadcrumb.prototype.clicked = function (toRouteName) {
        this.$emit('click', toRouteName);
        this.$router.push({ name: toRouteName });
    };
    Breadcrumb = __decorate([
        vue_class_component_esm
    ], Breadcrumb);
    return Breadcrumb;
}(external_vue_default.a));
/* harmony default export */ var Breadcrumbvue_type_script_lang_ts_ = (Breadcrumbvue_type_script_lang_ts_Breadcrumb);

// CONCATENATED MODULE: ./src/components/breadcrumb/Breadcrumb.vue?vue&type=script&lang=ts&
 /* harmony default export */ var breadcrumb_Breadcrumbvue_type_script_lang_ts_ = (Breadcrumbvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/breadcrumb/Breadcrumb.vue





/* normalize component */

var Breadcrumb_component = normalizeComponent(
  breadcrumb_Breadcrumbvue_type_script_lang_ts_,
  Breadcrumbvue_type_template_id_448e3c3c_render,
  Breadcrumbvue_type_template_id_448e3c3c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var breadcrumb_Breadcrumb = (Breadcrumb_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/Card.vue?vue&type=template&id=555c1cf6&
var Cardvue_type_template_id_555c1cf6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-card",class:{'clickable': _vm.clickable}},[_vm._t("default")],2)}
var Cardvue_type_template_id_555c1cf6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/card/Card.vue?vue&type=template&id=555c1cf6&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/card/Card.vue?vue&type=script&lang=ts&


var Cardvue_type_script_lang_ts_Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: true })
    ], Card.prototype, "clickable", void 0);
    Card = __decorate([
        vue_class_component_esm
    ], Card);
    return Card;
}(external_vue_default.a));
/* harmony default export */ var Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_Card);

// CONCATENATED MODULE: ./src/components/card/Card.vue?vue&type=script&lang=ts&
 /* harmony default export */ var card_Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/card/Card.vue





/* normalize component */

var Card_component = normalizeComponent(
  card_Cardvue_type_script_lang_ts_,
  Cardvue_type_template_id_555c1cf6_render,
  Cardvue_type_template_id_555c1cf6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var card_Card = (Card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expandable/ExpandableSection.vue?vue&type=template&id=0f3de74c&
var ExpandableSectionvue_type_template_id_0f3de74c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-expandable",class:{ 'expanded': _vm.expanded, 'expandable': _vm.expandable, 'bac-expandable-section--block': _vm.styleAsBlock }},[_c('div',{staticClass:"bac-expandable-section__header",attrs:{"tabindex":_vm.expandable ? 0 : -1},on:{"click":function($event){return _vm.toggleExpanded()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleExpanded()}}},[_vm._t("header"),(_vm.expandable)?_c('a',{staticClass:"bac-expandable-section__header__icon",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();}}},[_c('font-awesome-icon',{staticClass:"bac-expandable__icon-expand",class:{ 'expanded': _vm.expanded },attrs:{"icon":"chevron-down","size":"lg"}})],1):_vm._e()],2),_c('div',{staticClass:"bac-expandable__content",class:{'bac-expandable__content--large': _vm.large }},[_vm._t("default")],2)])}
var ExpandableSectionvue_type_template_id_0f3de74c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/expandable/ExpandableSection.vue?vue&type=template&id=0f3de74c&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expandable/ExpandableSection.vue?vue&type=script&lang=ts&


var ExpandableSectionvue_type_script_lang_ts_ExpandableSection = /** @class */ (function (_super) {
    __extends(ExpandableSection, _super);
    function ExpandableSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expanded = true;
        return _this;
    }
    ExpandableSection.prototype.created = function () {
        if (this.expandable) {
            this.expanded = this.open;
        }
    };
    ExpandableSection.prototype.onOpenChanged = function (open) {
        if (this.expandable) {
            this.expanded = open;
        }
    };
    ExpandableSection.prototype.toggleExpanded = function () {
        if (this.expandable) {
            this.setExpanded(!this.expanded);
        }
    };
    ExpandableSection.prototype.setExpanded = function (newValue) {
        this.expanded = newValue;
        return this.expanded;
    };
    __decorate([
        Prop({ default: true })
    ], ExpandableSection.prototype, "expandable", void 0);
    __decorate([
        Prop({ default: false })
    ], ExpandableSection.prototype, "open", void 0);
    __decorate([
        Prop({ default: false })
    ], ExpandableSection.prototype, "styleAsBlock", void 0);
    __decorate([
        Prop({ default: false })
    ], ExpandableSection.prototype, "large", void 0);
    __decorate([
        Watch('open')
    ], ExpandableSection.prototype, "onOpenChanged", null);
    __decorate([
        Emit('expand')
    ], ExpandableSection.prototype, "setExpanded", null);
    ExpandableSection = __decorate([
        vue_class_component_esm
    ], ExpandableSection);
    return ExpandableSection;
}(external_vue_default.a));
/* harmony default export */ var ExpandableSectionvue_type_script_lang_ts_ = (ExpandableSectionvue_type_script_lang_ts_ExpandableSection);

// CONCATENATED MODULE: ./src/components/expandable/ExpandableSection.vue?vue&type=script&lang=ts&
 /* harmony default export */ var expandable_ExpandableSectionvue_type_script_lang_ts_ = (ExpandableSectionvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/expandable/ExpandableSection.vue





/* normalize component */

var ExpandableSection_component = normalizeComponent(
  expandable_ExpandableSectionvue_type_script_lang_ts_,
  ExpandableSectionvue_type_template_id_0f3de74c_render,
  ExpandableSectionvue_type_template_id_0f3de74c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var expandable_ExpandableSection = (ExpandableSection_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expandable/ExpandableText.vue?vue&type=template&id=55217832&
var ExpandableTextvue_type_template_id_55217832_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-expandable-text",class:{ 'expanded': _vm.expanded },on:{"click":function($event){return _vm.toggleExpanded()}}},[_c('a',{staticClass:"bac-expandable-text__header",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();}}},[_c('span',{staticClass:"bac-expandable-text__header__title"},[(_vm.hasTitle)?_vm._t("title"):_c('span',[_vm._v(_vm._s(_vm.expanded ? 'Less info' : 'More info'))])],2),_c('font-awesome-icon',{staticClass:"bac-expandable__icon-expand",class:{ 'expanded': _vm.expanded },attrs:{"icon":"chevron-down","size":"lg"}})],1),_c('div',{staticClass:"bac-expandable__content"},[_vm._t("default")],2)])}
var ExpandableTextvue_type_template_id_55217832_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/expandable/ExpandableText.vue?vue&type=template&id=55217832&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/expandable/ExpandableText.vue?vue&type=script&lang=ts&


var ExpandableTextvue_type_script_lang_ts_ExpandableText = /** @class */ (function (_super) {
    __extends(ExpandableText, _super);
    function ExpandableText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expanded = false;
        return _this;
    }
    Object.defineProperty(ExpandableText.prototype, "hasTitle", {
        get: function () {
            return !!this.$slots.title;
        },
        enumerable: true,
        configurable: true
    });
    ExpandableText.prototype.toggleExpanded = function () {
        this.expanded = !this.expanded;
        return this.expanded;
    };
    __decorate([
        Emit('expand')
    ], ExpandableText.prototype, "toggleExpanded", null);
    ExpandableText = __decorate([
        vue_class_component_esm
    ], ExpandableText);
    return ExpandableText;
}(external_vue_default.a));
/* harmony default export */ var ExpandableTextvue_type_script_lang_ts_ = (ExpandableTextvue_type_script_lang_ts_ExpandableText);

// CONCATENATED MODULE: ./src/components/expandable/ExpandableText.vue?vue&type=script&lang=ts&
 /* harmony default export */ var expandable_ExpandableTextvue_type_script_lang_ts_ = (ExpandableTextvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/expandable/ExpandableText.vue





/* normalize component */

var ExpandableText_component = normalizeComponent(
  expandable_ExpandableTextvue_type_script_lang_ts_,
  ExpandableTextvue_type_template_id_55217832_render,
  ExpandableTextvue_type_template_id_55217832_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var expandable_ExpandableText = (ExpandableText_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/MobileNavigationBar.vue?vue&type=template&id=0cbb11de&
var MobileNavigationBarvue_type_template_id_0cbb11de_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-mobile-nav"},[_c('div',{staticClass:"bac-mobile-nav__navbar"},[_c('button',{staticClass:"bac-mobile-nav__navbar__button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.offcanvasMenuShown = !_vm.offcanvasMenuShown}}},[_c('font-awesome-icon',{staticClass:"text-white",attrs:{"icon":"bars"}})],1),_c('div',{staticClass:"ml-auto mr-3"},[_vm._t("right")],2)]),_c('transition',{attrs:{"name":"slide-in-from-left"}},[(_vm.offcanvasMenuShown)?_c('MobileOffcanvasMenu',{on:{"close":function($event){_vm.offcanvasMenuShown = false}}},[_vm._t("default")],2):_vm._e()],1)],1)}
var MobileNavigationBarvue_type_template_id_0cbb11de_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/navigation/MobileNavigationBar.vue?vue&type=template&id=0cbb11de&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/MobileOffcanvasMenu.vue?vue&type=template&id=20061b10&
var MobileOffcanvasMenuvue_type_template_id_20061b10_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.close()}}},[_c('div',{staticClass:"bac-mobile-offcanvas-menu__overlay"}),_c('div',{staticClass:"bac-mobile-offcanvas-menu__menu"},[_vm._t("default")],2)])}
var MobileOffcanvasMenuvue_type_template_id_20061b10_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/navigation/MobileOffcanvasMenu.vue?vue&type=template&id=20061b10&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/MobileOffcanvasMenu.vue?vue&type=script&lang=ts&


var MobileOffcanvasMenuvue_type_script_lang_ts_MobileNavigationBar = /** @class */ (function (_super) {
    __extends(MobileNavigationBar, _super);
    function MobileNavigationBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileNavigationBar.prototype.close = function () { };
    __decorate([
        Emit('close')
    ], MobileNavigationBar.prototype, "close", null);
    MobileNavigationBar = __decorate([
        vue_class_component_esm
    ], MobileNavigationBar);
    return MobileNavigationBar;
}(external_vue_default.a));
/* harmony default export */ var MobileOffcanvasMenuvue_type_script_lang_ts_ = (MobileOffcanvasMenuvue_type_script_lang_ts_MobileNavigationBar);

// CONCATENATED MODULE: ./src/components/navigation/MobileOffcanvasMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_MobileOffcanvasMenuvue_type_script_lang_ts_ = (MobileOffcanvasMenuvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/navigation/MobileOffcanvasMenu.vue





/* normalize component */

var MobileOffcanvasMenu_component = normalizeComponent(
  navigation_MobileOffcanvasMenuvue_type_script_lang_ts_,
  MobileOffcanvasMenuvue_type_template_id_20061b10_render,
  MobileOffcanvasMenuvue_type_template_id_20061b10_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MobileOffcanvasMenu = (MobileOffcanvasMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/MobileNavigationBar.vue?vue&type=script&lang=ts&



var MobileNavigationBarvue_type_script_lang_ts_MobileNavigationBar = /** @class */ (function (_super) {
    __extends(MobileNavigationBar, _super);
    function MobileNavigationBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.offcanvasMenuShown = false;
        return _this;
    }
    MobileNavigationBar = __decorate([
        vue_class_component_esm({
            components: {
                MobileOffcanvasMenu: MobileOffcanvasMenu,
            },
        })
    ], MobileNavigationBar);
    return MobileNavigationBar;
}(external_vue_default.a));
/* harmony default export */ var MobileNavigationBarvue_type_script_lang_ts_ = (MobileNavigationBarvue_type_script_lang_ts_MobileNavigationBar);

// CONCATENATED MODULE: ./src/components/navigation/MobileNavigationBar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_MobileNavigationBarvue_type_script_lang_ts_ = (MobileNavigationBarvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/navigation/MobileNavigationBar.vue





/* normalize component */

var MobileNavigationBar_component = normalizeComponent(
  navigation_MobileNavigationBarvue_type_script_lang_ts_,
  MobileNavigationBarvue_type_template_id_0cbb11de_render,
  MobileNavigationBarvue_type_template_id_0cbb11de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var navigation_MobileNavigationBar = (MobileNavigationBar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/NavigationBar.vue?vue&type=template&id=4527ae6e&
var NavigationBarvue_type_template_id_4527ae6e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-navbar"},[_vm._t("default")],2)}
var NavigationBarvue_type_template_id_4527ae6e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/navigation/NavigationBar.vue?vue&type=template&id=4527ae6e&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/NavigationBar.vue?vue&type=script&lang=ts&


var NavigationBarvue_type_script_lang_ts_NavigationBar = /** @class */ (function (_super) {
    __extends(NavigationBar, _super);
    function NavigationBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavigationBar = __decorate([
        vue_class_component_esm
    ], NavigationBar);
    return NavigationBar;
}(external_vue_default.a));
/* harmony default export */ var NavigationBarvue_type_script_lang_ts_ = (NavigationBarvue_type_script_lang_ts_NavigationBar);

// CONCATENATED MODULE: ./src/components/navigation/NavigationBar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_NavigationBarvue_type_script_lang_ts_ = (NavigationBarvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/navigation/NavigationBar.vue





/* normalize component */

var NavigationBar_component = normalizeComponent(
  navigation_NavigationBarvue_type_script_lang_ts_,
  NavigationBarvue_type_template_id_4527ae6e_render,
  NavigationBarvue_type_template_id_4527ae6e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var navigation_NavigationBar = (NavigationBar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/NavigationBarButton.vue?vue&type=template&id=5ec5c7e8&
var NavigationBarButtonvue_type_template_id_5ec5c7e8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-navbar-button d-flex flex-column"},[(_vm.fa)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_c('i',{class:_vm.icon}),(!!_vm.label)?_c('span',{staticClass:"bac-navbar-button__label pt-1 text-center"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()],1)}
var NavigationBarButtonvue_type_template_id_5ec5c7e8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/navigation/NavigationBarButton.vue?vue&type=template&id=5ec5c7e8&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/navigation/NavigationBarButton.vue?vue&type=script&lang=ts&


var NavigationBarButtonvue_type_script_lang_ts_NavigationBarButton = /** @class */ (function (_super) {
    __extends(NavigationBarButton, _super);
    function NavigationBarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop()
    ], NavigationBarButton.prototype, "icon", void 0);
    __decorate([
        Prop()
    ], NavigationBarButton.prototype, "fa", void 0);
    __decorate([
        Prop()
    ], NavigationBarButton.prototype, "label", void 0);
    NavigationBarButton = __decorate([
        vue_class_component_esm
    ], NavigationBarButton);
    return NavigationBarButton;
}(external_vue_default.a));
/* harmony default export */ var NavigationBarButtonvue_type_script_lang_ts_ = (NavigationBarButtonvue_type_script_lang_ts_NavigationBarButton);

// CONCATENATED MODULE: ./src/components/navigation/NavigationBarButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var navigation_NavigationBarButtonvue_type_script_lang_ts_ = (NavigationBarButtonvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/navigation/NavigationBarButton.vue





/* normalize component */

var NavigationBarButton_component = normalizeComponent(
  navigation_NavigationBarButtonvue_type_script_lang_ts_,
  NavigationBarButtonvue_type_template_id_5ec5c7e8_render,
  NavigationBarButtonvue_type_template_id_5ec5c7e8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var navigation_NavigationBarButton = (NavigationBarButton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slidefadetransition/SlideFadeTransition.vue?vue&type=template&id=59566b52&
var SlideFadeTransitionvue_type_template_id_59566b52_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"tag":"div","css":false},on:{"before-enter":_vm.beforeEnter,"appear":_vm.appear,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)}
var SlideFadeTransitionvue_type_template_id_59566b52_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/slidefadetransition/SlideFadeTransition.vue?vue&type=template&id=59566b52&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slidefadetransition/SlideFadeTransition.vue?vue&type=script&lang=ts&


var SlideFadeTransitionvue_type_script_lang_ts_SlideFadeTransition = /** @class */ (function (_super) {
    __extends(SlideFadeTransition, _super);
    function SlideFadeTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideFadeTransition.prototype.beforeEnter = function (element) {
        if (this.shouldAnimateElement(element)) {
            element.classList.add('slide-fade-enter');
        }
    };
    SlideFadeTransition.prototype.appear = function (element) {
        if (this.shouldAnimateElement(element)) {
            var delay = parseInt(element.dataset.index) * 50;
            this.animateElement(element, delay);
        }
    };
    SlideFadeTransition.prototype.enter = function (element) {
        this.animateElement(element, 0);
    };
    SlideFadeTransition.prototype.animateElement = function (element, delay) {
        setTimeout(function () {
            element.classList.add('slide-fade-enter-active');
            // Class can be removed as animation is still going.
            element.classList.remove('slide-fade-enter');
            setTimeout(function () { return element.classList.remove('slide-fade-enter-active'); }, 500);
        }, delay);
    };
    SlideFadeTransition.prototype.leave = function (element, done) {
        element.classList.add('slide-fade-leave-active');
        element.classList.add('slide-fade-leave-to');
        setTimeout(function () { return done(); }, 300);
    };
    SlideFadeTransition.prototype.shouldAnimateElement = function (element) {
        var index = parseInt(element.dataset.index);
        return index <= this.animateUntilIndex;
    };
    __decorate([
        Prop({ default: 40 })
    ], SlideFadeTransition.prototype, "animateUntilIndex", void 0);
    SlideFadeTransition = __decorate([
        vue_class_component_esm
    ], SlideFadeTransition);
    return SlideFadeTransition;
}(external_vue_default.a));
/* harmony default export */ var SlideFadeTransitionvue_type_script_lang_ts_ = (SlideFadeTransitionvue_type_script_lang_ts_SlideFadeTransition);

// CONCATENATED MODULE: ./src/components/slidefadetransition/SlideFadeTransition.vue?vue&type=script&lang=ts&
 /* harmony default export */ var slidefadetransition_SlideFadeTransitionvue_type_script_lang_ts_ = (SlideFadeTransitionvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/slidefadetransition/SlideFadeTransition.vue





/* normalize component */

var SlideFadeTransition_component = normalizeComponent(
  slidefadetransition_SlideFadeTransitionvue_type_script_lang_ts_,
  SlideFadeTransitionvue_type_template_id_59566b52_render,
  SlideFadeTransitionvue_type_template_id_59566b52_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slidefadetransition_SlideFadeTransition = (SlideFadeTransition_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slideover/SlideOver.vue?vue&type=template&id=fe3cec8e&
var SlideOvervue_type_template_id_fe3cec8e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-slide-over__panel"},[_c('div',{staticClass:"bac-slide-over__header"},[_c('a',{staticClass:"bac-slide-over__header__back",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.back()}}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left","size":"lg"}})],1),_vm._t("header"),_c('a',{ref:"close",staticClass:"bac-slide-over__header__close",attrs:{"autofocus":"","href":""},on:{"click":function($event){$event.preventDefault();return _vm.closeAll()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeAll()}}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"lg"}})],1)],2),_c('div',{staticClass:"bac-slide-over__content"},[_vm._t("default")],2)])}
var SlideOvervue_type_template_id_fe3cec8e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/slideover/SlideOver.vue?vue&type=template&id=fe3cec8e&

// CONCATENATED MODULE: ./src/services/slideover/slideOverService.ts

var slideOverService_SlideOverService = /** @class */ (function () {
    function SlideOverService() {
    }
    SlideOverService.prototype.openSlideOver = function (config) {
        store.commit('bacComponents/slideOver/open', config);
    };
    SlideOverService.prototype.closeCurrentSlideOver = function () {
        store.commit('bacComponents/slideOver/close');
    };
    SlideOverService.prototype.closeAllSlideOvers = function () {
        store.commit('bacComponents/slideOver/closeAll');
    };
    return SlideOverService;
}());

var slideOverService = new slideOverService_SlideOverService();

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slideover/SlideOver.vue?vue&type=script&lang=ts&



var SlideOvervue_type_script_lang_ts_SlideOver = /** @class */ (function (_super) {
    __extends(SlideOver, _super);
    function SlideOver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlideOver.prototype.created = function () {
        if (!this.$store) {
            throw new Error("The SlideOver component depends on Vuex.\n      Please add Vuex to your project and pass the store as a plugin option.");
        }
    };
    SlideOver.prototype.mounted = function () {
        this.$refs.close.focus();
    };
    SlideOver.prototype.back = function () {
        slideOverService.closeCurrentSlideOver();
    };
    SlideOver.prototype.closeAll = function () {
        slideOverService.closeAllSlideOvers();
    };
    __decorate([
        Emit('close')
    ], SlideOver.prototype, "back", null);
    __decorate([
        Emit()
    ], SlideOver.prototype, "closeAll", null);
    SlideOver = __decorate([
        vue_class_component_esm
    ], SlideOver);
    return SlideOver;
}(external_vue_default.a));
/* harmony default export */ var SlideOvervue_type_script_lang_ts_ = (SlideOvervue_type_script_lang_ts_SlideOver);

// CONCATENATED MODULE: ./src/components/slideover/SlideOver.vue?vue&type=script&lang=ts&
 /* harmony default export */ var slideover_SlideOvervue_type_script_lang_ts_ = (SlideOvervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/slideover/SlideOver.vue





/* normalize component */

var SlideOver_component = normalizeComponent(
  slideover_SlideOvervue_type_script_lang_ts_,
  SlideOvervue_type_template_id_fe3cec8e_render,
  SlideOvervue_type_template_id_fe3cec8e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slideover_SlideOver = (SlideOver_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slideover/SlideOvers.vue?vue&type=template&id=e14afbb4&
var SlideOversvue_type_template_id_e14afbb4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-slide-overs"},[_c('transition',{attrs:{"name":"fade-40"}},[(_vm.panels.length > 0)?_c('div',{staticClass:"bac-slide-overs__overlay",on:{"click":function($event){return _vm.closeAll()}}}):_vm._e()]),_c('transition-group',{attrs:{"name":"slide-in-from-right"}},_vm._l((_vm.panels),function(panel,index){return _c(panel.component,{key:("" + index),tag:"component",attrs:{"data":panel.data}})}),1)],1)}
var SlideOversvue_type_template_id_e14afbb4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/slideover/SlideOvers.vue?vue&type=template&id=e14afbb4&

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("2f62");

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/bindings.js


var State = createBindingHelper('computed', vuex_esm["d" /* mapState */]);
var Getter = createBindingHelper('computed', vuex_esm["b" /* mapGetters */]);
var Action = createBindingHelper('methods', vuex_esm["a" /* mapActions */]);
var Mutation = createBindingHelper('methods', vuex_esm["c" /* mapMutations */]);
function bindings_namespace(namespace, helper) {
    function createNamespacedHelper(helper) {
        function namespacedHelper(a, b) {
            if (typeof b === 'string') {
                var key = b;
                var proto = a;
                return helper(key, { namespace: namespace })(proto, key);
            }
            var type = a;
            var options = merge(b || {}, { namespace: namespace });
            return helper(type, options);
        }
        return namespacedHelper;
    }
    if (helper) {
        console.warn('[vuex-class] passing the 2nd argument to `namespace` function is deprecated. pass only namespace string instead.');
        return createNamespacedHelper(helper);
    }
    return {
        State: createNamespacedHelper(State),
        Getter: createNamespacedHelper(Getter),
        Mutation: createNamespacedHelper(Mutation),
        Action: createNamespacedHelper(Action)
    };
}
function createBindingHelper(bindTo, mapFn) {
    function makeDecorator(map, namespace) {
        return createDecorator(function (componentOptions, key) {
            if (!componentOptions[bindTo]) {
                componentOptions[bindTo] = {};
            }
            var mapObject = (_a = {}, _a[key] = map, _a);
            componentOptions[bindTo][key] = namespace !== undefined
                ? mapFn(namespace, mapObject)[key]
                : mapFn(mapObject)[key];
            var _a;
        });
    }
    function helper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return makeDecorator(key, undefined)(proto, key);
        }
        var namespace = extractNamespace(b);
        var type = a;
        return makeDecorator(type, namespace);
    }
    return helper;
}
function extractNamespace(options) {
    var n = options && options.namespace;
    if (typeof n !== 'string') {
        return undefined;
    }
    if (n[n.length - 1] !== '/') {
        return n + '/';
    }
    return n;
}
function merge(a, b) {
    var res = {};
    [a, b].forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            res[key] = obj[key];
        });
    });
    return res;
}

// CONCATENATED MODULE: ./node_modules/vuex-class/lib/index.js


// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/slideover/SlideOvers.vue?vue&type=script&lang=ts&




var SlideOversvue_type_script_lang_ts_SlideOvers = /** @class */ (function (_super) {
    __extends(SlideOvers, _super);
    function SlideOvers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SlideOvers.prototype, "panels", {
        get: function () {
            return this.slideOverState.panels;
        },
        enumerable: true,
        configurable: true
    });
    SlideOvers.prototype.created = function () {
        if (!this.$store) {
            throw new Error("The SlideOver component depends on Vuex.\n      Please add Vuex to your project and pass the store as a plugin option.");
        }
    };
    SlideOvers.prototype.closeAll = function () {
        slideOverService.closeAllSlideOvers();
    };
    SlideOvers.prototype.onPanelsChanged = function (panels) {
        if (panels.length > 0) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
    };
    __decorate([
        State(function (state) { return state.bacComponents.slideOver; })
    ], SlideOvers.prototype, "slideOverState", void 0);
    __decorate([
        Emit()
    ], SlideOvers.prototype, "closeAll", null);
    __decorate([
        Watch('panels')
    ], SlideOvers.prototype, "onPanelsChanged", null);
    SlideOvers = __decorate([
        vue_class_component_esm
    ], SlideOvers);
    return SlideOvers;
}(external_vue_default.a));
/* harmony default export */ var SlideOversvue_type_script_lang_ts_ = (SlideOversvue_type_script_lang_ts_SlideOvers);

// CONCATENATED MODULE: ./src/components/slideover/SlideOvers.vue?vue&type=script&lang=ts&
 /* harmony default export */ var slideover_SlideOversvue_type_script_lang_ts_ = (SlideOversvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/slideover/SlideOvers.vue





/* normalize component */

var SlideOvers_component = normalizeComponent(
  slideover_SlideOversvue_type_script_lang_ts_,
  SlideOversvue_type_template_id_e14afbb4_render,
  SlideOversvue_type_template_id_e14afbb4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slideover_SlideOvers = (SlideOvers_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/spinner/Spinner.vue?vue&type=template&id=0cca0172&
var Spinnervue_type_template_id_0cca0172_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-spinner"},[_c('font-awesome-icon',{staticClass:"bac-spinner__icon",attrs:{"icon":"plane","size":"2x"}})],1)}
var Spinnervue_type_template_id_0cca0172_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/spinner/Spinner.vue?vue&type=template&id=0cca0172&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/spinner/Spinner.vue?vue&type=script&lang=ts&


var Spinnervue_type_script_lang_ts_Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner = __decorate([
        vue_class_component_esm
    ], Spinner);
    return Spinner;
}(external_vue_default.a));
/* harmony default export */ var Spinnervue_type_script_lang_ts_ = (Spinnervue_type_script_lang_ts_Spinner);

// CONCATENATED MODULE: ./src/components/spinner/Spinner.vue?vue&type=script&lang=ts&
 /* harmony default export */ var spinner_Spinnervue_type_script_lang_ts_ = (Spinnervue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/spinner/Spinner.vue





/* normalize component */

var Spinner_component = normalizeComponent(
  spinner_Spinnervue_type_script_lang_ts_,
  Spinnervue_type_template_id_0cca0172_render,
  Spinnervue_type_template_id_0cca0172_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var spinner_Spinner = (Spinner_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/spinner/SpinnerInline.vue?vue&type=template&id=61ae0de9&
var SpinnerInlinevue_type_template_id_61ae0de9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-spinner-inline"},[_c('font-awesome-icon',{staticClass:"bac-spinner-inline__icon",attrs:{"icon":"plane"}})],1)}
var SpinnerInlinevue_type_template_id_61ae0de9_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/spinner/SpinnerInline.vue?vue&type=template&id=61ae0de9&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/spinner/SpinnerInline.vue?vue&type=script&lang=ts&


var SpinnerInlinevue_type_script_lang_ts_SpinnerInline = /** @class */ (function (_super) {
    __extends(SpinnerInline, _super);
    function SpinnerInline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerInline = __decorate([
        vue_class_component_esm
    ], SpinnerInline);
    return SpinnerInline;
}(external_vue_default.a));
/* harmony default export */ var SpinnerInlinevue_type_script_lang_ts_ = (SpinnerInlinevue_type_script_lang_ts_SpinnerInline);

// CONCATENATED MODULE: ./src/components/spinner/SpinnerInline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var spinner_SpinnerInlinevue_type_script_lang_ts_ = (SpinnerInlinevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/spinner/SpinnerInline.vue





/* normalize component */

var SpinnerInline_component = normalizeComponent(
  spinner_SpinnerInlinevue_type_script_lang_ts_,
  SpinnerInlinevue_type_template_id_61ae0de9_render,
  SpinnerInlinevue_type_template_id_61ae0de9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var spinner_SpinnerInline = (SpinnerInline_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tile/Tile.vue?vue&type=template&id=d9e32630&
var Tilevue_type_template_id_d9e32630_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bac-card',{staticClass:"bac-tile",class:'bac-tile--' + _vm.size},[_vm._t("default"),_c('div',{staticClass:"bac-tile__icon"},[_vm._t("icon")],2)],2)}
var Tilevue_type_template_id_d9e32630_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/tile/Tile.vue?vue&type=template&id=d9e32630&

// CONCATENATED MODULE: ./src/models/tile/tileModel.ts
var TileSize;
(function (TileSize) {
    TileSize["Small"] = "small";
    TileSize["Regular"] = "regular";
})(TileSize || (TileSize = {}));

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tile/Tile.vue?vue&type=script&lang=ts&



var Tilevue_type_script_lang_ts_Tile = /** @class */ (function (_super) {
    __extends(Tile, _super);
    function Tile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: TileSize.Regular })
    ], Tile.prototype, "size", void 0);
    Tile = __decorate([
        vue_class_component_esm
    ], Tile);
    return Tile;
}(external_vue_default.a));
/* harmony default export */ var Tilevue_type_script_lang_ts_ = (Tilevue_type_script_lang_ts_Tile);

// CONCATENATED MODULE: ./src/components/tile/Tile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var tile_Tilevue_type_script_lang_ts_ = (Tilevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/tile/Tile.vue





/* normalize component */

var Tile_component = normalizeComponent(
  tile_Tilevue_type_script_lang_ts_,
  Tilevue_type_template_id_d9e32630_render,
  Tilevue_type_template_id_d9e32630_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tile_Tile = (Tile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ce7f10b0-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/user-menu/UserMenu.vue?vue&type=template&id=209b2561&
var UserMenuvue_type_template_id_209b2561_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bac-user-menu",class:{'bac-user-menu--inverse': _vm.inverse}},[_c('div',{staticClass:"bac-user-menu__button",class:{'bac-user-menu__button--selected': _vm.showDropdown},attrs:{"tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.toggleDropdown($event)}}},[_c('font-awesome-icon',{staticClass:"font-size-xl",attrs:{"icon":"user-circle"}}),_c('div',{staticClass:"bac-user-menu__label"},[_vm._v(_vm._s(_vm.username))]),_c('font-awesome-icon',{attrs:{"icon":"caret-down"}})],1),_c('transition',{attrs:{"name":"slide-out"}},[(_vm.showDropdown)?_c('ul',{staticClass:"list-unstyled bac-user-menu__list"},[_vm._t("default"),_c('li',{staticClass:"bac-user-menu__list__item",attrs:{"tabindex":"0"},on:{"click":_vm.logout,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logout($event)}}},[_c('font-awesome-icon',{staticClass:"fa-fw bac-user-menu__list__item__icon",attrs:{"icon":"sign-out-alt"}}),_c('span',[_vm._v("Logout")])],1)],2):_vm._e()])],1)}
var UserMenuvue_type_template_id_209b2561_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/user-menu/UserMenu.vue?vue&type=template&id=209b2561&

// CONCATENATED MODULE: ./node_modules/ts-loader??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/user-menu/UserMenu.vue?vue&type=script&lang=ts&


var UserMenuvue_type_script_lang_ts_UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    function UserMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showDropdown = false;
        return _this;
    }
    UserMenu.prototype.toggleDropdown = function () {
        this.showDropdown = !this.showDropdown;
        this.$emit(this.showDropdown ? 'opened' : 'closed');
        if (this.showDropdown) {
            document.body.addEventListener('click', this.toggleDropdown);
            document.body.addEventListener('keypress', this.keyEventHandler);
        }
        else {
            document.body.removeEventListener('click', this.toggleDropdown);
            document.body.removeEventListener('keypress', this.keyEventHandler);
        }
    };
    UserMenu.prototype.logout = function () { };
    UserMenu.prototype.keyEventHandler = function (event) {
        var key = event.which || event.keyCode;
        if (key === 13 || key === 27) {
            // Enter or escape
            this.toggleDropdown();
        }
    };
    __decorate([
        Prop()
    ], UserMenu.prototype, "username", void 0);
    __decorate([
        Prop({ default: false })
    ], UserMenu.prototype, "inverse", void 0);
    __decorate([
        Emit()
    ], UserMenu.prototype, "logout", null);
    UserMenu = __decorate([
        vue_class_component_esm
    ], UserMenu);
    return UserMenu;
}(external_vue_default.a));
/* harmony default export */ var UserMenuvue_type_script_lang_ts_ = (UserMenuvue_type_script_lang_ts_UserMenu);

// CONCATENATED MODULE: ./src/components/user-menu/UserMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var user_menu_UserMenuvue_type_script_lang_ts_ = (UserMenuvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/components/user-menu/UserMenu.vue





/* normalize component */

var UserMenu_component = normalizeComponent(
  user_menu_UserMenuvue_type_script_lang_ts_,
  UserMenuvue_type_template_id_209b2561_render,
  UserMenuvue_type_template_id_209b2561_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var user_menu_UserMenu = (UserMenu_component.exports);
// CONCATENATED MODULE: ./src/components/index.ts
// components
















var components = {
    BacBlock: block_Block,
    BacBreadcrumb: breadcrumb_Breadcrumb,
    BacCard: card_Card,
    BacExpandableSection: expandable_ExpandableSection,
    BacExpandableText: expandable_ExpandableText,
    BacMobileNavigationBar: navigation_MobileNavigationBar,
    BacMobileOffcanvasMenu: MobileOffcanvasMenu,
    BacNavigationBar: navigation_NavigationBar,
    BacNavigationBarButton: navigation_NavigationBarButton,
    BacSlideFadeTransition: slidefadetransition_SlideFadeTransition,
    BacSlideOver: slideover_SlideOver,
    BacSlideOvers: slideover_SlideOvers,
    BacSpinner: spinner_Spinner,
    BacSpinnerInline: spinner_SpinnerInline,
    BacTile: tile_Tile,
    BacUserMenu: user_menu_UserMenu,
};

// CONCATENATED MODULE: ./src/directives/DocumentTitle.ts
var directiveOptions = {
    inserted: function (el, binding) { return setDocumentTitle(binding); },
    update: function (el, binding) { return setDocumentTitle(binding); },
};
function setDocumentTitle(binding) {
    document.title = binding.value;
}
/* harmony default export */ var DocumentTitle = (directiveOptions);

// CONCATENATED MODULE: ./src/directives/index.ts
// directives

var directives = {
    BacDocumentTitle: DocumentTitle,
};

// CONCATENATED MODULE: ./src/services/index.ts


// CONCATENATED MODULE: ./src/models/index.ts


// CONCATENATED MODULE: ./src/index.ts


// All components to be registered by the plugin

// All directives to be registered by the plugin



var bacComponentsPlugin = {
    install: function (vue, options) {
        if (options && options.store) {
            initStore(options.store);
        }
        initFontAwesome(vue);
        // globally register all components and directives
        Object.keys(components).forEach(function (name) { return vue.component(name, components[name]); });
        Object.keys(directives).forEach(function (name) { return vue.directive(name, directives[name]); });
    },
};
/* harmony default export */ var src = (bacComponentsPlugin);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport bacSlideOverService */__webpack_require__.d(__webpack_exports__, "bacSlideOverService", function() { return slideOverService; });
/* concated harmony reexport SlideOverService */__webpack_require__.d(__webpack_exports__, "SlideOverService", function() { return slideOverService_SlideOverService; });
/* concated harmony reexport TileSize */__webpack_require__.d(__webpack_exports__, "TileSize", function() { return TileSize; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ })

/******/ });
//# sourceMappingURL=bac-frontend-common.common.js.map